module.exports = __webpack_public_path__ + "static/img/8.9808abc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/8.png
// module id = wajI
// module chunks = 0